<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12>
                <v-stepper v-model="step" class="mx-auto stepper-custom">
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">Bienvenid@</v-stepper-step>
                        <v-divider/>
                        <v-stepper-step v-if="isPaymentRequired" :complete="step > 2" step="2">Pago</v-stepper-step>
                        <v-divider/>
                        <v-stepper-step :step="finalStep">Ingresar</v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card class="mb-12" color="transparent" flat min-height="350px">
                                <h1 class="headline mt-4">¡Hola {{ vc.client.first_name }}!</h1>
                                <p class="subtitle my-4">
                                    Antes de ingresar a tu cita, necesitamos verificar algunos pasos.
                                </p>
                                <v-btn color="primary" round @click="start">
                                    Continuar
                                    <v-icon class="ml-2" size="18">fa-arrow-right</v-icon>
                                </v-btn>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content v-if="isPaymentRequired" step="2">
                            <v-card v-if="loadingPayment" class="mb-12" color="transparent" flat min-height="350px">
                                <h1 class="headline mt-4">Se esta verificando su pago</h1>
                                <v-progress-linear height="2" :indeterminate="true" class="my-4"/>
                                <v-btn color="primary" round @click="loadingPayment = false">
                                    <v-icon class="mr-2" size="18">fa-redo-alt</v-icon>
                                    Reintentar
                                </v-btn>
                            </v-card>
                            <v-card class="mb-12" color="transparent" flat min-height="350px" v-else>
                                <h1 class="headline mt-4">Paga tu Cita</h1>
                                <p class="subtitle my-4">{{ paymentText }}</p>
                                <v-btn color="primary" round @click="requestPayment" v-if="showPaymentButton">
                                    <v-icon class="mr-2" size="18">fa-shopping-cart</v-icon>
                                    Realizar Pago
                                </v-btn>
                                <v-btn color="primary" round @click="step = finalStep" v-else>
                                    Continuar
                                    <v-icon class="ml-2" size="18">fa-arrow-right</v-icon>
                                </v-btn>
                            </v-card>
                        </v-stepper-content>

                        <v-stepper-content :step="finalStep">
                            <v-card class="mb-12 mx-auto" color="transparent" flat max-width="500" min-height="350px">
                                <h1 class="headline">¡Genial!</h1>
                                <p class="subtitle mb-4 mt-2">por favor, indícanos el motivo de tu consulta</p>

                                <template
                                    v-if="payment.status === 'success' || payment.status === 'done' || !payment.required">

                                    <appointment-reason-picker
                                        ref="reasonPicker"
                                        label="Selecciona uno del listado"
                                        :public="true"
                                        :outline="true"
                                        :hide-details="true"
                                        :provider="vc && vc.specialist.provider_id"
                                        :error-messages="reasonError"
                                        v-on:change="onReasonSelect"/>

                                    <div class="title my-2">ó</div>

                                    <v-textarea
                                        dense
                                        clearable
                                        hide-details
                                        height="80"
                                        v-model="createReason"
                                        outline
                                        label="Escríbelo"
                                        class="mb-4 pa-1"
                                    />

                                    <v-btn
                                        :disabled="!reason && !createReason"
                                        color="primary"
                                        class="mb-4"
                                        round
                                        :loading="loadingArrive"
                                        @click="setArrive"
                                    >
                                        <v-icon class="mr-2" size="18">fa-video</v-icon>
                                        Ir a la Videollamada
                                    </v-btn>
                                </template>
                            </v-card>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>


</template>

<script>

import {mapMutations} from 'vuex'

import {ApiUtils} from '@/utils/ApiUtils'
import {subscribeToPublicChannelEvents, leaveChannel} from '@/utils/Sockets'

import AppointmentReasonPicker from '@/components/appointments/AppointmentReasonPicker'

export default {
    props: {
        vc: {
            type: Object,
            required: true
        }
    },
    components: {AppointmentReasonPicker},
    data(vm) {
        return {
            step: 1,
            loadingVC: false,
            loadingArrive: false,
            reason: vm.vc.reason || null,
            createReason: '',
            reasonError: '',
            payment: vm.vc.payment || {
                required: false,
                id: null,
                status: 'pending',
                status_detail: 'pending'
            },
            loadingPayment: false,
        }
    },
    computed: {
        isPaymentRequired() {
            const vm = this
            return !!vm.payment && vm.payment.required
        },
        finalStep(vm = this) {
            return vm.isPaymentRequired ? 3 : 2
        },
        paymentText(vm = this) {
            switch (vm.payment.status) {
                case 'done':
                    return 'Tu pago ya ha sido procesado correctamente.'
                case 'refuse':
                    return 'No pudimos procesar tu pago. Intentalo nuevamente con otro medio de pago.'
                case 'cancel':
                    return 'El pago ha sido cancelado, puedes volver a intentarlo.'
                default:
                    return 'Para realizar el pago de la atención sigue el siguiente enlace'
            }
        },
        paymentReturn(vm = this) {
            return vm.$route.query.paymentResponse === 'return'
        },
        showPaymentButton(vm = this) {
            return vm.payment.status !== 'done'
        }
    },
    mounted() {
        const vm = this

        if (vm.payment.id) {
            subscribeToPublicChannelEvents(`payment.${vm.payment.id}`, {
                'PaymentUpdated': vm.onPaymentUpdated
            })
        }

        if (vm.paymentReturn) {
            vm.$nextTick(function () {
                vm.step = 2
            })
        }
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        start() {
            const vm = this
            !vm.payment.required ? vm.step = vm.finalStep : vm.step = 2
        },
        async setArrive() {
            const vm = this
            if (vm.loadingArrive) return

            vm.loadingArrive = true
            const response = await ApiUtils.makePost(`appointments/${vm.vc.schedule_event.id}/arrive/video`, {
                appointment_reason_id: vm.reason && vm.reason.id || null,
                create_appointment_reason: vm.createReason
            })

            if (!response.ok) {
                const json = await response.json()
                vm.loadingArrive = false
                return vm.showSnackBar({
                    text: json.message || 'Ocurrió un error intentando ingresar a la cita',
                    color: 'error'
                })
            }

            vm.$emit('done')
            vm.loadingArrive = false
        },
        async requestPayment() {
            const vm = this
            window.open(vm.vc.payment.url, '_blank')
            vm.loadingPayment = true
        },
        onPaymentUpdated(entity) {
            const vm = this
            vm.payment = entity.event.payment
        },
        onReasonSelect(reason) {
            this.reason = reason
        }
    },
    beforeDestroy() {
        const vm = this
        if (vm.payment.id) leaveChannel(`payments.${vm.payment.id}`)
    },
    watch: {
        createReason(val) {
            if (val) this.$refs.reasonPicker.clearSearch()
        },
        reason(val) {
            if (val) this.createReason = ''
        },
        vc(val) {
            this.payment = val.payment
        },
        payment(val, oldVal) {
            const vm = this
            if (val) {
                subscribeToPublicChannelEvents(`payment.${val.id}`, {
                    'PaymentUpdated': vm.onPaymentUpdated
                })

                vm.payment.status === 'done' ?
                    vm.$nextTick(() => {
                        vm.step = vm.finalStep
                    }) :
                    vm.$nextTick(() => {
                        vm.step = 1
                    })

            } else {
                leaveChannel(`payments.${oldVal.id}`)
            }

        }
    }
}
</script>

<style scoped>
.stepper-custom {
    border-radius: 10px !important;
    background-color: rgba(255, 255, 255, .8);
}
</style>